import type {StateCreator} from 'zustand'
import type {NewTreeEntry, OldTreeEntry} from '../../types'

export type TreeEntriesSliceOpts = {
  newTreeEntry?: NewTreeEntry | null | undefined
  oldTreeEntry?: OldTreeEntry | null | undefined
}

export interface TreeEntriesSlice {
  treeEntries: {
    newTreeEntry: NewTreeEntry | null | undefined
    oldTreeEntry: OldTreeEntry | null | undefined
  }
}

export const createTreeEntriesSlice =
  ({newTreeEntry, oldTreeEntry}: TreeEntriesSliceOpts): StateCreator<TreeEntriesSlice, [['zustand/devtools', never]]> =>
  () => ({
    treeEntries: {
      newTreeEntry,
      oldTreeEntry,
    },
  })
